import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      quote:
        "Shay and Vantage Point Media have exceeded my expectations. I have been working with them for over a year on my personal brand and different businesses. My ultimate goal was to hire someone and not even having to think about social media and they have gone way beyond. I look forward to the continued partnership with Vantage Point Media.",
      author: 'Ryan G.',
      role: 'Business Owner',
      rating: 5,
    },
    {
      quote:
        "The team at VPM transformed our online presence completely. Within 3 months, we saw a 250% increase in new patient inquiries. Their understanding of the med spa industry is unmatched.",
      author: 'Dr. Sarah M.',
      role: 'Med Spa Director',
      rating: 5,
    },
    {
      quote:
        "Professional, creative, and results-driven. VPM helped us create content that truly resonates with our target audience. Our social engagement has never been higher.",
      author: 'Michael T.',
      role: 'Financial Advisor',
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16">
          <span className="inline-block text-accent font-semibold text-sm uppercase tracking-wider mb-3 sm:mb-4">
            Client Success
          </span>
          <h2 className="font-display font-bold text-2xl sm:text-4xl lg:text-5xl text-foreground mb-4 sm:mb-6">
            Hear What Our
            <span className="text-accent"> Clients Say</span>
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            Don't just take our word for it—see what professionals like you have achieved with our partnership.
          </p>
        </div>

        {/* Video Testimonials */}
        <div className="grid md:grid-cols-2 gap-4 sm:gap-8 mb-10 sm:mb-16">
          {[
            { id: 'WPBiU4O__EY', label: 'Client Testimonial 1' },
            { id: 'Odamt82-cxw', label: 'Client Testimonial 2' },
          ].map((video, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-soft border border-border bg-card aspect-video"
            >
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${video.id}`}
                title={video.label}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
              />
            </div>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-2xl p-5 sm:p-8 shadow-soft hover:shadow-medium transition-all duration-300 relative group"
            >
              {/* Quote Icon */}
              <div className="absolute -top-3 sm:-top-4 left-6 sm:left-8 bg-accent p-2 sm:p-3 rounded-xl shadow-soft">
                <Quote className="w-4 h-4 sm:w-5 sm:h-5 text-accent-foreground" />
              </div>

              {/* Stars */}
              <div className="flex gap-0.5 sm:gap-1 mb-4 sm:mb-6 pt-3 sm:pt-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-secondary text-secondary" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-sm sm:text-base text-foreground/90 leading-relaxed mb-4 sm:mb-6">
                "{testimonial.quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-hero rounded-full flex items-center justify-center">
                  <span className="text-primary-foreground font-semibold text-sm sm:text-base">
                    {testimonial.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-sm sm:text-base text-foreground">{testimonial.author}</div>
                  <div className="text-xs sm:text-sm text-muted-foreground">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
